module.exports = __webpack_public_path__ + "static/media/Human_ZG4577-Edit_360.b35f03d8.jpeg";